import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const generateSummary = async (recordingId: string) => {
  const response = await axiosClient.post(
    `/recordings/${recordingId}/summarise`,
  );
  return response.data;
};

function useGenerateSummary(
  recordingId: string,
  options?: Partial<
    UseMutationOptions<void, HttpError, { recordingId: string }>
  >,
) {
  return useMutation({
    mutationFn: () => generateSummary(recordingId),
    mutationKey: ["generate-summary", recordingId],
    ...options,
  });
}

export { useGenerateSummary };
